export const countryCodes = {
  br: "BR",
  us: "US",
} as const;

export const isSameCountryCode = (
  a: string | undefined,
  b: string | undefined,
): boolean => {
  const sanitizedA = a?.toUpperCase()?.trim() ?? "";
  const sanitizedB = b?.toUpperCase()?.trim() ?? "";
  return Boolean(sanitizedA && sanitizedB && sanitizedA === sanitizedB);
};
